import {View} from 'react-native';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import GrpReferralRedesign from 'src/components/img/svg/GrpReferralredesign';
import Styles from 'src/components/Styles';
import Localized from 'src/constants/AppStrings';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

export function getReferralStyles(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    referralTitle: {
      marginTop: Styles.Spacing.m2 + Styles.Spacing.m3,
      fontSize: getLayoutDescriber().headerFontSize(),
      fontWeight: 'bold',
      textAlign: 'center',
      fontFamily: Styles.FontFamily.gothamRegular,
      color: Styles.Colors.Aramark.primary,
    },
    referralDesc: {
      marginTop: Styles.Spacing.m2 + Styles.Spacing.m1,
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '400',
      textAlign: 'center',
      fontFamily: Styles.FontFamily.gothamRegular,
      color: Styles.tabBarTextColor,
    },
    referralExpiry: {
      marginTop: Styles.Spacing.m3,
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '400',
      textAlign: 'center',
      fontStyle: 'italic',
      fontFamily: Styles.FontFamily.gothamRegular,
      color: Styles.Colors.Aramark.primary,
    },
    totalReferralsKey: {
      fontSize: getLayoutDescriber().bodySmallFontSize(),
      fontWeight: '400',
      textAlign: 'center',
      fontFamily: Styles.FontFamily.gothamRegular,
      color: Styles.Colors.Aramark.lightGrey,
      lineHeight: 14,
    },
    totalReferralsValue: {
      fontSize: getLayoutDescriber().headerFontSize(),
      fontWeight: 'bold',
      textAlign: 'left',
      fontFamily: Styles.FontFamily.gothamRegular,
      color: Styles.tabBarTextColor,
    },
    shareViaEmailTitle: {
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '400',
      textAlign: 'left',
      fontFamily: Styles.FontFamily.gothamRegular,
      color: Styles.tabBarTextColor,
    },
    errorLabel: {
      color: Styles.dangerColor,
      fontSize: getLayoutDescriber().bodySmallFontSize(),
      fontFamily: Styles.FontFamily.gothamRegular,
      alignSelf: 'flex-start',
      marginHorizontal: Styles.Spacing.m3,
      marginTop: Styles.Spacing.m1,
    },
    orText: {
      fontSize: getLayoutDescriber().bodyFontSize(),
      textTransform: 'uppercase',
      color: Styles.tabBarTextColor,
      fontFamily: Styles.FontFamily.gothamRegular,
      marginHorizontal: Styles.Spacing.m3,
    },
  };
}

export function getReferralTitleMsg(
  amount: string,
  transactionMinimum?: string,
): string {
  return Localized.Labels.formatString(
    Localized.Labels.referral_invite_earn_desc,
    'Breaks Reimagined',
    transactionMinimum,
    amount,
  ).toString();
}

export function getReferralHeaderIcon() {
  return (
    <GrpReferralRedesign
      width={78}
      height={74}
      gradColor1={Styles.Colors.Aramark.primary}
      gradColor2={Styles.Colors.Aramark.primary}
    />
  );
}

export function getSendInviteButton(
  checkDisabled: () => boolean,
  callback: () => void,
) {
  return (
    <View
      style={{
        alignSelf: 'flex-end',
        marginVertical: Styles.Spacing.m3 + Styles.Spacing.m2,
      }}
    >
      <RoundedAppButton
        buttonType={RoundedAppButtonType.Solid}
        onPress={callback}
        isDisabled={checkDisabled()}
        inActiveButtonViewStyle={{
          backgroundColor: Styles.Colors.Aramark.lightGrey,
        }}
        inActiveTextStyle={[
          {
            fontFamily: Styles.FontFamily.gothamRegular,
            fontSize: getLayoutDescriber().bodyFontSize(),
          },
        ]}
        textStyle={[
          {
            fontFamily: Styles.FontFamily.gothamRegular,
            fontSize: getLayoutDescriber().bodyFontSize(),
          },
        ]}
        accessibilityLabelValue="Send Invite"
        titleText={Localized.Buttons.send_invite}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
      />
    </View>
  );
}

export default {
  getReferralStyles,
  getReferralTitleMsg,
  getReferralHeaderIcon,
  getSendInviteButton,
};
